export function scrollToElement(el: Element | null, offsetTop = 0): void {
    if (!el) return;

    const targetOffsetTop = getElementOffset(el).top;

    const documentScrollTop = window.pageYOffset || document.documentElement?.scrollTop || 0;

    const distanceFromTarget = targetOffsetTop - documentScrollTop - offsetTop;

    window.scrollBy({
        top: distanceFromTarget,
        behavior: 'smooth',
    });
}

// Get an element's absolute position on the page.
function getElementOffset(el: Element) {
    const rect = el.getBoundingClientRect();

    return {
        left: rect.left + (window.scrollX || window.pageXOffset),
        top: rect.top + (window.scrollY || window.pageYOffset),
    };
}

export function scrollToElementById(id: string, offsetTop = 0): void {
    const el = document.getElementById(id);
    if (el) {
        scrollToElement(el, offsetTop);
    }
}
